








































import Vue from "vue";
import _ from "lodash";
import { Rules } from "@ct/validations";
import { AuthRepository } from "@ct/auth";
import SIGN_IN_MUTATION from "@/graphql/SignInMutation.gql";
import { SignInMutation, SignInMutationVariables } from "@/graphql/generatedTypes/SignInMutation";
import { AlertBar } from "@ct/alert";
import globalState from "@/globalState";
import { Auth } from "@ct/auth/src/AuthRepository";

export default Vue.extend({
  name: "SignIn",
  metaInfo: {
    title: "Intro To IMS - Sign In",
    meta: [
      {
        property: "og:title",
        content: "Intro To IMS - Sign In"
      },
      {
        property: "og:image",
        content: "https://res.cloudinary.com/dm1xkelzx/image/upload/q_auto/v1686607172/IMS_Triangle_hcfwcc.png"
      }
    ]
  },
  components: { AlertBar },
  data() {
    return {
      email: "",
      password: "",
      rules: Rules,
      errors: { email: [], password: [] } as { [key: string]: string[] }
    };
  },
  methods: {
    async signIn() {
      globalState.loading += 1;

      const result = await this.$apollo.mutate<SignInMutation, SignInMutationVariables>({
        mutation: SIGN_IN_MUTATION,
        variables: {
          email: this.email,
          password: this.password
        }
      });

      globalState.loading -= 1;

      if (!_.isEmpty(result.data?.signIn?.errors)) {
        // eslint-disable-next-line no-unused-expressions
        result.data?.signIn?.errors.map(error => {
          const { path } = error;
          this.errors[path].push(error.message);
        });
        return;
      }

      if (result.data && result.data.signIn) {
        AuthRepository.signIn(result.data.signIn as Auth);
        if (this.$route.query?.from) {
          await this.$router.push({
            path: this.$route.query.from as string,
            query: { join: this.$route?.query?.join, email: this.$route?.query?.email }
          });

          return;
        }
        await this.$router.push({
          name: "users_group_path",
          params: { userId: (result.data.signIn.currentUser?.id as string) ?? undefined }
        });
      }
    }
  }
});
